import classNames from 'clsx';
import React from 'react';
import type { RouteComponentProps } from 'react-router';

import CasinoGameInfoCard from '@swf/components/CasinoGameInfoCard/CasinoGameInfoCard';
import PageNotFound from '@swf/components/PageNotFound/PageNotFound';
import CloseButton, { Variant } from '@swf/components/StarsModal/components/CloseButton';
import type { CasinoGame } from '@swf/core/types/CasinoGame';

import styles from './CasinoGameInfo.scss';

interface LocationStateProps {
  game: CasinoGame;
  raceId?: string;
  fsbLaunch?: boolean;
}

const CasinoGameInfo: React.FC<RouteComponentProps<object, object, LocationStateProps>> = (
  props
) => {
  const { game, raceId, fsbLaunch } = props.location.state || {};

  return (
    <div className={classNames(styles.container)}>
      <CloseButton className={styles.closeButton} variant={Variant.Light} />
      {!game ? (
        <PageNotFound isModal />
      ) : (
        <CasinoGameInfoCard isModal {...game} fsbLaunch={fsbLaunch} raceId={raceId} />
      )}
    </div>
  );
};

export default CasinoGameInfo;
